import React, { useState, useEffect } from "react";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { useHistory } from "react-router-dom";
import { selectUser } from "../../modules/Auth/_redux/authRedux";
import { useSelector, useDispatch } from "react-redux";
import {
  selectData,
  fetchAll,
  fetchApproval,
  fetchComplate,
  fetchPending,
  selectDataPending,
  selectDataApproval,
  selectDataComplate,
  selectLoading,
  selectPageNo,
  selectPageSize,
  selectTotalRecord,
  selectPageSizeNew,
  selectPageNoNew,
  selectTotalRecordNew,
} from "./dashboardSlice";
import { NewRegistartionTable } from "./NewRegistartionTable";
import { NeedAppovalTable } from "./NeedApprovalTable";
import { LayoutSplashScreen } from "../../../_metronic/layout";

export function DashboardPage({ className, symbolShape, baseColor }) {
  ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
  );
  const user = useSelector(selectUser);
  const dispatch = useDispatch();
  const history = useHistory();
  const loading = useSelector(selectLoading);
  const data = useSelector(selectData);
  const dataApproval = useSelector(selectDataApproval);
  const dataComplate = useSelector(selectDataComplate);
  const dataPending = useSelector(selectDataPending);
  const pageNo = useSelector(selectPageNo);
  const pageSize = useSelector(selectPageSize);
  const totalRecord = useSelector(selectTotalRecord);
  const pageNoNew = useSelector(selectPageNoNew);
  const pageSizeNew = useSelector(selectPageSizeNew);
  const totalRecordNew = useSelector(selectTotalRecordNew);

  console.log(pageNo, "pageNo");
  console.log(pageSize, "pageSize");
  console.log(totalRecord, "totalRecord");

  // map permision
  const role = user.roles.map((e) => {
    return e.roleName;
  });
  const permisionRole = role.toString();

  const newRegistrationAllowed = [
    "ADMIN",
    "SALES_SERVICE",
    "ADMINISTRATOR",
    "OPERATION_HO",
    "DISPLAY",
    "DISPLAY_ONLY",
  ];

  const needApprovalAllowed = [
    "ADMIN",
    "ADMINISTRATOR",
    "OPERATION_HO",
    "ASM",
    "NSM",
    "BM",
    "QAHO",
    "BRQA",
    "CHIEF_DELIVERY",
    "CHIEF_WAREHOUSE",
    "CLIENT",
    "FSS",
    "DISPLAY",
    "DISPLAY_ONLY",
  ];

  const completeProcessAllowed = [
    "OPERATION_HO",
    "ADMIN",
    "ADMINISTRATOR",
    "DISPLAY",
    "DISPLAY_ONLY",
  ];

  const pendingProcessAllowed = [
    "OPERATION_HO",
    "SALES_SERVICE",
    "ADMIN",
    "ADMINISTRATOR",
    "DISPLAY",
    "DISPLAY_ONLY",
  ];

  const checkRoles = (userRoles, allowedRoles) => {
    return userRoles.some((e) => allowedRoles.includes(e));
  };

  const usernameFIlter = user.userName;

  // useEffect(() => {
  //   // Fetch data on first load
  // }, []);

  useEffect(() => {
    async function fetchMyAPI() {
      {
        checkRoles(role, newRegistrationAllowed) &&
          (await dispatch(
            fetchAll({
              username: usernameFIlter,
              pageNo: 1,
              pageSize: 10,
            })
          ));
      }
      {
        checkRoles(role, needApprovalAllowed) &&
          (await dispatch(
            fetchApproval({
              username: usernameFIlter,
              pageNo: 1,
              pageSize: 10,
            })
          ));
      }
      // {
      //   checkRoles(role, needApprovalAllowed) &&
      //     (await dispatch(
      //       fetchComplate({
      //         username: usernameFIlter,
      //       })
      //     ));
      // }

      {
        checkRoles(role, pendingProcessAllowed) &&
          (await dispatch(
            fetchPending({
              username: "",
            })
          ));
      }
    }

    fetchMyAPI();
  }, []);

  let pendingBrqa = 0;
  let pendingSales = 0;
  let pendingClient = 0;
  let pendingQAHO = 0;
  let pendingCD = 0;
  let pendingCW = 0;

  if (dataPending !== null) {
    dataPending.map((step) => {
      if (step.step_code === "BRQA") {
        return (pendingBrqa = step.total);
      } else {
      }
    });
  }
  if (dataPending !== null) {
    dataPending.map((step) => {
      if (step.step_code === "SALES") {
        return (pendingSales = step.total);
      } else {
      }
    });
  }
  if (dataPending !== null) {
    dataPending.map((step) => {
      if (step.step_code === "CLIENT") {
        return (pendingClient = step.total);
      } else {
      }
    });
  }
  if (dataPending !== null) {
    dataPending.map((step) => {
      if (step.step_code === "QAHO") {
        return (pendingQAHO = step.total);
      } else {
      }
    });
  }

  if (dataPending !== null) {
    dataPending.map((step) => {
      if (step.step_code === "CD") {
        return (pendingCD = step.total);
      } else {
      }
    });
  }

  if (dataPending !== null) {
    dataPending.map((step) => {
      if (step.step_code === "CW") {
        return (pendingCW = step.total);
      } else {
      }
    });
  }

  const handleTableChangeNeed = (type, { page, sizePerPage }) => {
    const params = {
      username: usernameFIlter,
      pageNo: page,
      pageSize: sizePerPage,
    };
    dispatch(fetchAll(params));
  };

  const handleTableChangeApproval = (type, { page, sizePerPage }) => {
    const params = {
      username: usernameFIlter,
      pageNo: page,
      pageSize: sizePerPage,
    };
    dispatch(fetchApproval(params));
  };

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <>
      {/* card approval*/}
      <div className="container  pl-0 pr-0">
        {/* header */}
        <div className="row">
          {/* new registration */}
          {checkRoles(role, newRegistrationAllowed) && (
            <div className="col-md-6 col-xs-12 mb-3 ">
              <div className={`card card-custom p-0 m-0 ${className}`}>
                <div className="card-body p-0 m-0 bg-light-success">
                  <div className="d-flex p-0 m-0 align-items-center justify-content-between card-spacer-dashboard flex-grow-1 ">
                    <span
                      className={`symbol ${symbolShape} symbol-50 symbol-light mr-2`}
                    >
                      <span className="symbol-label">
                        <span className="svg-icon svg-icon-3x svg-icon-success d-block my-2">
                          <SVG
                            src={toAbsoluteUrl(
                              "/media/svg/icons/Files/File-plus.svg"
                            )}
                          ></SVG>
                        </span>
                      </span>
                    </span>
                    <div className="d-flex flex-column text-right">
                      <span className="text-dark-75 font-weight-bolder font-size-h2">
                        {totalRecordNew}
                      </span>
                      <span className="text-dark-75 font-weight-bold mt-2">
                        New Registration
                      </span>
                    </div>
                  </div>
                  <div
                    id="kt_stats_widget_10_chart"
                    className="card-rounded-bottom"
                    data-color={baseColor}
                    style={{ height: "10px", visibility: "hidden" }}
                  />
                </div>
              </div>
            </div>
          )}
          {/* Needs Approval */}

          {checkRoles(role, needApprovalAllowed) && (
            <div className="col-md-6 col-xs-12 mb-3 ">
              <div className={`card card-custom ${className}`}>
                {/* begin::Body */}
                <div className="card-body p-0 bg-light-danger">
                  <div className="d-flex align-items-center justify-content-between card-spacer-dashboard flex-grow-1">
                    <span
                      className={`symbol ${symbolShape} symbol-50 symbol-light mr-2`}
                    >
                      <span className="symbol-label">
                        <span className="svg-icon svg-icon-3x svg-icon-danger d-block my-2">
                          <SVG
                            src={toAbsoluteUrl(
                              "/media/svg/icons/Navigation/Waiting.svg"
                            )}
                          ></SVG>
                        </span>
                      </span>
                    </span>
                    <div className="d-flex flex-column text-right">
                      <span className="text-dark-75 font-weight-bolder font-size-h2">
                        {totalRecord}
                      </span>
                      <span className="text-dark-75 font-weight-bold mt-2">
                        Needs Approval
                      </span>
                    </div>
                  </div>
                  <div
                    id="kt_stats_widget_10_chart"
                    className="card-rounded-bottom"
                    data-color={baseColor}
                    style={{ height: "10px", visibility: "hidden" }}
                  />
                </div>
                {/* end::Body */}
              </div>{" "}
            </div>
          )}

          {/* complete Proses */}
          {/* {checkRoles(role, completeProcessAllowed) && (
            <div className="col-md-4 col-xs-12 mb-3 ">
              <div className={`card card-custom ${className}`}>
                <div className="card-body p-0 bg-light-primary">
                  <div className="d-flex align-items-center justify-content-between card-spacer-dashboard flex-grow-1">
                    <span
                      className={`symbol ${symbolShape} symbol-50 symbol-light mr-2`}
                    >
                      <span className="symbol-label">
                        <span className="svg-icon svg-icon-3x svg-icon-primary d-block my-2">
                          <SVG
                            src={toAbsoluteUrl(
                              "/media/svg/icons/Files/File-done.svg"
                            )}
                          ></SVG>
                        </span>
                      </span>
                    </span>
                    <div className="d-flex flex-column text-right">
                      <span className="text-dark-75 font-weight-bolder font-size-h2">
                        {dataComplate < 1 ? 0 : `${dataComplate[0].total}`}
                      </span>
                      <span className="text-dark-75 font-weight-bold mt-2">
                        Complete Process
                      </span>
                    </div>
                  </div>
                  <div
                    id="kt_stats_widget_10_chart"
                    className="card-rounded-bottom"
                    data-color={baseColor}
                    style={{ height: "10px", visibility: "hidden" }}
                  />
                </div>
              </div>
            </div>
          )} */}
        </div>
      </div>

      {/* card Pending Process*/}
      {checkRoles(role, pendingProcessAllowed) && (
        <div className="container  pl-0 pr-0">
          {/* header */}
          <div className="row">
            {/* FSS */}
            <div className="col-md-2 col-xs-12 mb-3 ">
              <div className={`card card-custom p-0 m-0 ${className}`}>
                <div className="card-body p-0 m-0 bg-light-primary">
                  <div className="d-flex p-0 m-0 align-items-center justify-content-between card-spacer-dashboard flex-grow-1 ">
                    <span
                      className={`symbol ${symbolShape} symbol-50 symbol-light mr-2`}
                    >
                      <span className="text-dark-75 font-weight-bold mt-2">
                        FSS/ASM/BM
                      </span>
                    </span>
                    <div className="d-flex flex-column text-right">
                      <span className="text-dark-75 font-weight-bolder font-size-h2">
                        {pendingSales}
                      </span>
                    </div>
                  </div>
                  <div
                    id="kt_stats_widget_10_chart"
                    className="card-rounded-bottom"
                    data-color={baseColor}
                    style={{ height: "10px", visibility: "hidden" }}
                  />
                </div>
              </div>
            </div>
            {/* CLIENT */}
            <div className="col-md-2 col-xs-12 mb-3 ">
              <div className={`card card-custom ${className}`}>
                {/* begin::Body */}
                <div className="card-body p-0 bg-light-primary">
                  <div className="d-flex align-items-center justify-content-between card-spacer-dashboard flex-grow-1">
                    <span
                      className={`symbol ${symbolShape} symbol-50 symbol-light mr-2`}
                    >
                      <span className="text-dark-75 font-weight-bold mt-2">
                        CLIENT
                      </span>
                    </span>
                    <div className="d-flex flex-column text-right">
                      <span className="text-dark-75 font-weight-bolder font-size-h2">
                        {pendingClient}
                      </span>
                    </div>
                  </div>
                  <div
                    id="kt_stats_widget_10_chart"
                    className="card-rounded-bottom"
                    data-color={baseColor}
                    style={{ height: "10px", visibility: "hidden" }}
                  />
                </div>
                {/* end::Body */}
              </div>{" "}
            </div>
            {/* BRQA */}
            <div className="col-md-2 col-xs-12 mb-3 ">
              <div className={`card card-custom ${className}`}>
                {/* begin::Body */}
                <div className="card-body p-0 bg-light-primary">
                  <div className="d-flex align-items-center justify-content-between card-spacer-dashboard flex-grow-1">
                    <span
                      className={`symbol ${symbolShape} symbol-50 symbol-light mr-2`}
                    >
                      <span className="text-dark-75 font-weight-bold mt-2">
                        BRQA
                      </span>
                    </span>
                    <div className="d-flex flex-column text-right">
                      <span className="text-dark-75 font-weight-bolder font-size-h2">
                        {pendingBrqa}
                      </span>
                    </div>
                  </div>
                  <div
                    id="kt_stats_widget_10_chart"
                    className="card-rounded-bottom"
                    data-color={baseColor}
                    style={{ height: "10px", visibility: "hidden" }}
                  />
                </div>
                {/* end::Body */}
              </div>{" "}
            </div>
            {/* QAHO */}
            <div className="col-md-2 col-xs-12 mb-3 ">
              <div className={`card card-custom ${className}`}>
                {/* begin::Body */}
                <div className="card-body p-0 bg-light-primary">
                  <div className="d-flex align-items-center justify-content-between card-spacer-dashboard flex-grow-1">
                    <span
                      className={`symbol ${symbolShape} symbol-50 symbol-light mr-2`}
                    >
                      <span className="text-dark-75 font-weight-bold mt-2">
                        QAHO
                      </span>
                    </span>
                    <div className="d-flex flex-column text-right">
                      <span className="text-dark-75 font-weight-bolder font-size-h2">
                        {pendingQAHO}
                      </span>
                    </div>
                  </div>
                  <div
                    id="kt_stats_widget_10_chart"
                    className="card-rounded-bottom"
                    data-color={baseColor}
                    style={{ height: "10px", visibility: "hidden" }}
                  />
                </div>
                {/* end::Body */}
              </div>{" "}
            </div>

            {/* CD */}

            <div className="col-md-2 col-xs-12 mb-3 ">
              <div className={`card card-custom ${className}`}>
                {/* begin::Body */}
                <div className="card-body p-0 bg-light-primary">
                  <div className="d-flex align-items-center justify-content-between card-spacer-dashboard flex-grow-1">
                    <span
                      className={`symbol ${symbolShape} symbol-50 symbol-light mr-2`}
                    >
                      <span className="text-dark-75 font-weight-bold mt-2">
                        CD
                      </span>
                    </span>
                    <div className="d-flex flex-column text-right">
                      <span className="text-dark-75 font-weight-bolder font-size-h2">
                        {pendingCD}
                      </span>
                    </div>
                  </div>
                  <div
                    id="kt_stats_widget_10_chart"
                    className="card-rounded-bottom"
                    data-color={baseColor}
                    style={{ height: "10px", visibility: "hidden" }}
                  />
                </div>
                {/* end::Body */}
              </div>{" "}
            </div>

            <div className="col-md-2 col-xs-12 mb-3 ">
              <div className={`card card-custom ${className}`}>
                {/* begin::Body */}
                <div className="card-body p-0 bg-light-primary">
                  <div className="d-flex align-items-center justify-content-between card-spacer-dashboard flex-grow-1">
                    <span
                      className={`symbol ${symbolShape} symbol-50 symbol-light mr-2`}
                    >
                      <span className="text-dark-75 font-weight-bold mt-2">
                        CW
                      </span>
                    </span>
                    <div className="d-flex flex-column text-right">
                      <span className="text-dark-75 font-weight-bolder font-size-h2">
                        {pendingCW}
                      </span>
                    </div>
                  </div>
                  <div
                    id="kt_stats_widget_10_chart"
                    className="card-rounded-bottom"
                    data-color={baseColor}
                    style={{ height: "10px", visibility: "hidden" }}
                  />
                </div>
                {/* end::Body */}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* table */}
      <div className="containter">
        <div className="row">
          {/* table New Registration */}
          {checkRoles(role, newRegistrationAllowed) && (
            <div className="col-md-12 col-xs-12 mb-3 ">
              <div className={`card card-custom ${className}`}>
                {/* Header */}
                <div className="card-header">
                  <h3 className="card-title font-weight-bolder text-dark">
                    New Registration
                  </h3>
                </div>

                {/* Body 1*/}
                <div
                  className="card-body pt-0   "
                  style={{
                    height: `${
                      permisionRole === "SALES_SERVICE" ? "520px" : "230px"
                    }`,
                    overflowY: "scroll",
                  }}
                >
                  <div className="mb-6">
                    <NewRegistartionTable
                      data={data}
                      page={pageNoNew}
                      sizePerPage={pageSizeNew}
                      totalSize={totalRecordNew}
                      onTableChange={handleTableChangeNeed}
                      loading={loading}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* table need Aproval */}
          {checkRoles(role, needApprovalAllowed) && (
            <div className="col-md-12 col-xs-12 mb-3">
              {/* end::Stats Widget Need Approval */}
              <div className={`card card-custom ${className}`}>
                {/* Header */}
                <div className="card-header ">
                  <h3 className="card-title font-weight-bolder text-dark">
                    Need Approval
                  </h3>
                </div>
                {/* Body 1*/}
                <div
                  className="card-body pt-0"
                  style={{
                    height: `${
                      permisionRole === "ASM" ||
                      permisionRole === "NSM" ||
                      permisionRole === "BM" ||
                      permisionRole === "QAHO" ||
                      permisionRole === "BRQA" ||
                      permisionRole === "CHIEF_DELIVERY" ||
                      permisionRole === "CHIEF_WAREHOUSE" ||
                      permisionRole === "CLIENT" ||
                      permisionRole === "FSS"
                        ? "520px"
                        : "230px"
                    }`,
                    overflowY: "scroll",
                  }}
                >
                  <div className="mb-6">
                    <NeedAppovalTable
                      data={dataApproval}
                      page={pageNo}
                      sizePerPage={pageSize}
                      totalSize={totalRecord}
                      onTableChange={handleTableChangeApproval}
                      loading={loading}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      {/* end Approval */}

      {/* Chardt*/}

      {/* <div className="container mt-10 pl-0 pr-0">
        <div className={`card card-custom ${className}`}>
          <div className="card-body d-flex flex-column p-0 chart">
            <Bar options={options} data={dataChart} />
          </div>
        </div>
      </div> */}
    </>
  );
}
